import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';

import {CompareItems} from '../items/compare/CompareItems';
import {CompareModals} from '../items/compare/CompareFunctions';
import {ErrorModal} from '../error-handling/ErrorModal';
import {ImpUrl} from '../../client/imp-url/imp-url.class';
import {itemQuickviewComponentName, ItemQuickViewModal} from '../items/item-detail/item-quick-view/ItemQuickViewModal';
import {OrderItemsWorkflow} from '../../client/order-items/order-items.workflow';
import {UserStateService} from '../../client/users/user-state.service';
import {User} from '../users/user.class';
import {useService} from '../react/ServiceContext';

export interface CatalogPageProps {
    catalogUrl: string;
    userData: User;
}

export const CatalogPage = ({catalogUrl, userData}: CatalogPageProps) => {
    const [errorMessage, setErrorMessage] = useState(``);
    const [isClient, setIsClient] = useState(false);
    const [itemQuickViewModalState, setItemQuickViewModalState] = useState({pageLabel: ``, quickViewItemNum: ``, show: false});
    const orderItemsWorkflow: OrderItemsWorkflow = useService(`orderItemsWorkflow`);
    const user = useMemo(() => new User(userData), [userData]);
    const userStateService: UserStateService = useService(`userStateService`);

    // Set isClient state
    useEffect(() => {
        setIsClient(true);
    }, []);

    // Perform initial render of ItemQuickViewModal on page load
    useEffect(() => {
        if (ImpUrl.getQueryParamVal(`popup`)) {
            setItemQuickViewModalState({pageLabel: ``, quickViewItemNum: ImpUrl.getQueryParamVal(`popup`), show: true});
        }
    }, []);

    // Process queued actions
    useEffect(() => {
        if (userStateService.hasPendingAddToOrder(itemQuickviewComponentName)) {
            orderItemsWorkflow.addToOrderModal(userStateService.addToOrderItems, itemQuickviewComponentName, true);
        }
        // Only run once per page load
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Listen to message events from iframe
    useEffect(() => {
        window.addEventListener(`message`, ({origin, data}) => {
            if (origin === `https://flyer.imperialsupplies.com` && data) {
                switch (data.action) {
                    case `quickview`:
                        setItemQuickViewModalState({pageLabel: ``, quickViewItemNum: data.pid, show: true});
                        break;
                    default:
                        setErrorMessage(`Unexpected Message: ${data.action}`);
                        break;
                }
            }
        });
    }, []);
    /**
     * Template
     */
    return (
        <>
            <iframe
                className="tw-w-full tw-h-[950px]"
                height={1000}
                src={catalogUrl}
                width={994}
            />
            {isClient && <CompareItems />}
            <CompareModals />
            <ErrorModal
                errorMsg={errorMessage}
                onClose={() => setErrorMessage(``)}
                show={!!errorMessage}
            />
            <ItemQuickViewModal
                itemNumber={itemQuickViewModalState.quickViewItemNum}
                onCatalogPage={true}
                onHide={() => {
                    setItemQuickViewModalState({pageLabel: ``, quickViewItemNum: ``, show: false});
                }}
                pageLabel={itemQuickViewModalState.pageLabel}
                show={itemQuickViewModalState.show}
                user={user}
            />
        </>
    );
};
